import "./App.css";
import NavBar, { NavBarItem } from "./components/NavBar";
import HomeScreen from "./components/HomeScreen";
import { Route, Routes } from "react-router";
import {
  PrivacyPolicy as PrivacyPolicyPage,
  TermsOfService as TermsOfServicePage,
} from "./components/Legal";

function HomePage() {
  return (
    <div>
      <div className="fixed z-10 w-full">
        <NavBar>
          <NavBarItem name="About" linkTo="#about" />
          <NavBarItem name="Community" linkTo="#community" />
          <NavBarItem name="Getting started" linkTo="#getting-started" />
          <NavBarItem name="Download" linkTo="#download" />
        </NavBar>
      </div>
      <HomeScreen />
    </div>
  );
}

function App() {
  return (
    <div className="bg-background min-h-screen ">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy_policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms_of_service" element={<TermsOfServicePage />} />
      </Routes>
    </div>
  );
}

export default App;
